export default __webpack_public_path__ + "static/media/LOA_Vanquis.6596747f.pdf";